import * as React from 'react';

export interface QuoteBlockProps {
	/** Testo citato/corpo del blocco. */
	children: React.ReactNode;
}

/** Blocco bordato per testo citato/corpo, dentro dialog e viste di dettaglio. */
const QuoteBlock = ({ children }: QuoteBlockProps) => (
	<p className="rounded-lg border border-border bg-background p-3 text-[13px] leading-relaxed text-text-primary">
		{children}
	</p>
);
QuoteBlock.displayName = 'QuoteBlock';

export { QuoteBlock };
